import React, { useEffect, useState } from 'react';
import { api, AD_KIND_LABEL, type MarkAd } from '../../api';
import { getTheme, useThemeMode } from '../../theme';
import { adPath } from './AdList';
import { adsForMark } from './adPurchase';

/**
 * D5: de gamla vägarna ("Anmäl intresse", "Ansök om medlemskap") är stängda. Här pekar marken på sina
 * annonser i stället – där köper man eller ansöker (jaktlag och gratis grupper utan kort).
 * Utan onOpenAd öppnas annonsens sida (/annons/:id).
 */
export function MarkAdsPointer({ markId, onOpenAd, cta = false }: { markId: string; onOpenAd?: (ad: MarkAd) => void; cta?: boolean }) {
  const { mode } = useThemeMode();
  const T = getTheme(mode);
  const [ads, setAds] = useState<MarkAd[] | null>(null);
  useEffect(() => {
    let off = false;
    api.publishedAds().then(list => { if (!off) setAds(adsForMark(list, markId)); }).catch(() => { if (!off) setAds([]); });
    return () => { off = true; };
  }, [markId]);

  const open = (ad: MarkAd) => { if (onOpenAd) onOpenAd(ad); else window.location.href = adPath(ad); };
  const btn: React.CSSProperties = cta
    ? { width: '100%', background: T.accentFill, color: T.onAccent, border: 'none', borderRadius: 12, padding: 15, fontSize: 16, fontWeight: 800, cursor: 'pointer', fontFamily: 'inherit' }
    : { width: '100%', background: T.amber, color: '#000', border: 'none', borderRadius: 8, padding: 13, fontSize: 15, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' };

  if (!ads) return null;
  return (
    <div data-testid="mark-ads-pointer" style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: cta ? 0 : 12 }}>
      {ads.length === 0
        ? <div style={{ fontSize: 13, color: T.textSub, textAlign: 'center' }}>Marken har inga öppna annonser just nu. Ansökningar och köp görs via markens annonser.</div>
        : ads.map(ad => (
          <button key={ad.id} onClick={() => open(ad)} style={btn}>
            {ads.length === 1 ? 'Ansök via annonsen' : `${AD_KIND_LABEL[ad.kind]}: ${ad.title}`}
          </button>
        ))}
    </div>
  );
}
